import React from "react";
import { withLocalize } from "react-localize-redux";
import ExcelExportButton from '../common/excelExportButton';
import OldStyleSubsection from '../common/oldStyleSubsection';
import { SECTIONS } from "../../store/reportStore";

class ProcurementData extends React.Component {
    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? null : this.renderContent(this.props.data));
    }

    renderContent(data) {
        const key = SECTIONS.publicProcurements;
        return (<div>
            {data.map(summary => <OldStyleSubsection isBold
                key={`${key}_${summary.id}`}
                sectionId={this.props.sectionId}
                subsectionId={`${key}_${summary.id}`}
                subsectionName={this.props.translate(this.getSubsectionTranslationKey(summary.id, summary.country))}
                subsectionData={{ summary: summary }}
            />)}
            <ExcelExportButton link="public-procurements" entityId={this.props.id} report={this.props.reportType} />
        </div>);
    }

    getSubsectionTranslationKey = (type, country) => {
        if (type === "S")
            return country === "SK" ? "Report.Procurements.AsSupplier" : "Report.Procurements.WonProcurements";
        if (type === "A")
            return country === "SK" ? "Report.Procurements.AsAnnouncer" : "Report.Procurements.AnnouncedProcurements";
        return null;
    }
}

export default withLocalize(ProcurementData);
